module.exports = require("react-slick");


//////////////////
// WEBPACK FOOTER
// external "react-slick"
// module id = 35
// module chunks = 0